module.exports = __webpack_public_path__ + "static/img/preview.927632d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/the-beatles-rock-band-website/preview.png
// module id = 112
// module chunks = 2